// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_pMw","cls2":"ExportFormatModal-cls2_8hb ExportFormatModal-cls1_pMw"};